export default __webpack_public_path__ + "f7cc5c545093a5cdfec78f5b2f45750c.png";